import { DisplayType } from "./Picker.types";

export interface IDisplayTypeProps {
    displayType: DisplayType;
}

export function byDisplayType<T>(
    mapping: Record<DisplayType, T>,
): (props: IDisplayTypeProps) => T {
    return ({ displayType }: IDisplayTypeProps) => mapping[displayType];
}
